<template>
    <div>
        <md-card-content>
            <div style="table-container">
                <md-table class="table-hover">
                    <md-table-row>
                        <md-table-head>Id</md-table-head>
                        <md-table-head>Type</md-table-head>
                        <md-table-head>Date/Time</md-table-head>
                        <md-table-head>Address/Suburb</md-table-head>
                        <md-table-head>Distance</md-table-head>
                        <md-table-head>Duration</md-table-head>
                        <md-table-head v-if="hasTemperature">Tempurature</md-table-head>
                    </md-table-row>

                    <md-table-row v-for="(item, index) in driverData" :key="index" @click="viewAddress(item)">
                        <md-table-cell>
                            {{ index + 1 }}
                        </md-table-cell>
                        <md-table-cell>
                            <span>
                                {{ item.isStopEntry ? 'Stop' : 'Driving' }}
                            </span>
                        </md-table-cell>
                        <md-table-cell>
                            {{ displayDateTime(item) }}
                        </md-table-cell>
                        <md-table-cell>
                            <a v-if="item.isStopEntry" class="address" @click.stop="viewAddress(item)">
                                {{ displayAddress(item) }}
                            </a>
                            <span v-else>{{ item.drivingStartAddress }} -> {{ item.drivingEndAddress }}</span>
                        </md-table-cell>
                        <md-table-cell>
                            <span v-if="item.isStopEntry">
                                -
                            </span>
                            <span v-else>
                                {{ toDrivingDistanceStr(item.drivingDistanceToStop) }}
                            </span>
                        </md-table-cell>
                        <md-table-cell>
                            {{ item.stopTimeMinutes ? toTime(item.stopTimeMinutes) : '-' }}
                        </md-table-cell>
                        <md-table-cell v-if="hasTemperature" md-label="Avg Temperature">
                            {{ item.isStopEntry && item.stopAvgTemperature ? item.stopAvgTemperature / 100 : '-' }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <div class="label-total">
                    <span v-if="totalStops > 0">Total Stops: {{ totalStops }}</span>
                    <span>Total Distance: {{ toDistanceStr(memberData.dailyTravelDistance) }}</span>
                    <span>Total Time: {{ toTime(memberData.dailyTravelTimeMinutes) }}</span>
                </div>
            </div>
        </md-card-content>
    </div>
</template>

<script>
import moment from 'moment';
import { GeneralMixin } from '@/mixins';
import { DATE_TYPES } from '@/utils/constants';

import { ViewAddressModal } from '..';

export default {
    name: 'StopReportDetails',
    components: {},
    mixins: [GeneralMixin],
    props: {
        memberData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            DATE_TYPES
        };
    },
    computed: {
        driverData() {
            return this.memberData.driverData;
        },
        hasTemperature() {
            return this.memberData.driverData.some((obj) => obj.stopAvgTemperature != null);
        },
        user() {
            return this.$store.getters['user/user'];
        },
        totalStops() {
            return this.memberData.driverData.filter((item) => item.isStopEntry).length;
        },
        totalLocations() {
            return this.memberData.driverData.filter((item) => !item.isStopEntry).length;
        },
        speedUnits() {
            return this.user.speedUnits;
        }
    },
    methods: {
        displayDateTime(item) {
            if (item.dateTime)
                return moment(item.dateTime)
                    .utcOffset(item.utcOffset)
                    .format(DATE_TYPES.standardTime);

            return null;
        },
        displayAddress(item) {
            const houseAddr = [item.addressHouseNumber, item.addressRoad].filter((part) => part).join(' ');

            const addr = [houseAddr, item.addressSuburb, item.addressTown].filter((part) => part).join(', ');
            if (addr) {
                return addr;
            }

            return `${item.latitude} - ${item.longitude}`;
        },
        viewAddress(item) {
            if (!item.isStopEntry) 
                return;

            this.$modal.show(ViewAddressModal, { data: { location: item, address: this.displayAddress(item) } });
        },
        toTime(minutes) {
            const duration = moment.duration({ minutes: Math.ceil(minutes) });
            const formatted = moment.utc(duration.asMilliseconds()).format('HH [hr] mm [min]');

            return formatted;
        },
        toDistanceStr(dist) {
            if (!dist) 
                return '---';

            if (this.speedUnits === 'kph') 
                return `${Math.round(dist * 10) / 10} km`;

            return `${Math.round(dist * 0.621371 * 10) / 10} mi`;
        },
        toDrivingDistanceStr(drivingDistanceToStop) {
            if (!drivingDistanceToStop) 
                return '-';

            return `${(drivingDistanceToStop / 1000).toFixed(2)} km`;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .md-table-head-label {
    color: #4caf50 !important;
}

::v-deep .md-table-head {
    cursor: default;
}

.table-hover {
    cursor: pointer;
}

.label-total {
    float: right;
    font-size: 14px;
    font-weight: 500;
    span {
        display: block;
    }
}

.table-container {
    max-height: 600px;
    overflow-y: auto;
}
</style>
